module.exports = new __parcel__URL__("mission_rect.b0df653e.png").toString();